export default __webpack_public_path__ + "static/marrapodiarchitecture-e270bfc7cbf7e5f26e0602146bbe3b38.jpg";